<template>
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M4 5C4 4.73478 4.10536 4.48043 4.29289 4.29289C4.48043 4.10536 4.73478 4 5 4H11.172C11.4372 4.00006 11.6915 4.10545 11.879 4.293L19.879 12.293C20.0665 12.4805 20.1718 12.7348 20.1718 13C20.1718 13.2652 20.0665 13.5195 19.879 13.707L13.707 19.879C13.5195 20.0665 13.2652 20.1718 13 20.1718C12.7348 20.1718 12.4805 20.0665 12.293 19.879L4.293 11.879C4.10545 11.6915 4.00006 11.4372 4 11.172V5ZM5 2C4.20435 2 3.44129 2.31607 2.87868 2.87868C2.31607 3.44129 2 4.20435 2 5V11.172C2.00044 11.9672 2.3166 12.7298 2.879 13.292L10.879 21.292C11.4416 21.8544 12.2045 22.1704 13 22.1704C13.7955 22.1704 14.5584 21.8544 15.121 21.292L21.293 15.122C21.5716 14.8434 21.7927 14.5127 21.9434 14.1487C22.0942 13.7847 22.1719 13.3945 22.1719 13.0005C22.1719 12.6065 22.0942 12.2163 21.9434 11.8523C21.7927 11.4883 21.5716 11.1576 21.293 10.879L13.293 2.879C12.7305 2.31635 11.9676 2.00017 11.172 2H5ZM8 10C8.53043 10 9.03914 9.78929 9.41421 9.41421C9.78929 9.03914 10 8.53043 10 8C10 7.46957 9.78929 6.96086 9.41421 6.58579C9.03914 6.21071 8.53043 6 8 6C7.46957 6 6.96086 6.21071 6.58579 6.58579C6.21071 6.96086 6 7.46957 6 8C6 8.53043 6.21071 9.03914 6.58579 9.41421C6.96086 9.78929 7.46957 10 8 10Z"
			:fill="color"
		/>
	</svg>
</template>

<script>
export default {
	props: {
		color: {
			type: String,
			default: '#597393',
		},
	},
};
</script>
